

export const getSelectedProvider = () => {
   let selectedProvider = null;
    if (!window.ethereum?.providers) {
        // Only one provider avaiable, so switch networks using one
        selectedProvider = window.ethereum;
      } else {
        for (let provider of window.ethereum?.providers) {
            if (provider.isMetaMask && localStorage.getItem('connectedWalletProvider') === 'MetaMask') {
                selectedProvider = provider
            } else if (provider.isCoinbaseWallet && localStorage.getItem('connectedWalletProvider') === 'CoinBase') {
                selectedProvider = provider
            }
        }
      }

      return selectedProvider;

}

export const getCutWalletAddress = (address: String) => {
    return address.substring(0,6) + '..' + address.substring(address.length - 4);
}

export const sleep = (ms: number) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };
